<div class="row" *ngIf="listData">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> {{ 'PRODUCT.PRODUCT_DATA' | translate }}</div>
                <div class="tools">
                    <!-- <button type="button" class="btn btn-primary btn-sm" *ngIf="listData.state.id == 'AWAITING'">
                        <i class="bi bi bi-trash"></i> Удалить данные
                    </button> -->
                    <button type="button" class="btn btn-light btn-sm btn-pos-i"(click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>

                    <button type="button" class="btn btn-primary btn-sm" (click)="onEdit()">
                        <i class="bi bi-pencil-square"></i> {{ 'EDIT_DATA' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'DENOMINATION' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.product_name}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">GTIN: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.gtin}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'FILES.DATE_OF_CREATE' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.create_date}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'PRICE.DATE_THE_INVITATION' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.sending_date}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'STATUS' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.state.name}}</div>
                    </div>
                </div>
                <div class="row" *ngIf="listData.state.id == 'ERROR' || listData.state.id == 'FULL_REPORT_ERROR'">
                    <div class="col-5">
                        <div class="notification-info-title">{{ 'COUSE_OF_ERROR' | translate }}: </div>
                    </div>
                    <div class="col-7">
                        <div class="org-info-value">{{listData.error_message}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="loading" *ngIf="!listData">
    <div *ngIf="listData"> {{ 'LOADING' | translate }}</div>
    <div *ngIf="!listData">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>